import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1468.23529 C1053.44753,1468.23529 1129.41176,1544.19953 1129.41176,1637.64706 C1129.41176,1731.09459 1053.44753,1807.05882 960,1807.05882 C866.552471,1807.05882 790.588235,1731.09459 790.588235,1637.64706 C790.588235,1544.19953 866.552471,1468.23529 960,1468.23529 Z M960,790.588235 C1053.44753,790.588235 1129.41176,866.552471 1129.41176,960 C1129.41176,1053.44753 1053.44753,1129.41176 960,1129.41176 C866.552471,1129.41176 790.588235,1053.44753 790.588235,960 C790.588235,866.552471 866.552471,790.588235 960,790.588235 Z M960,112.941176 C1053.44753,112.941176 1129.41176,188.905412 1129.41176,282.352941 C1129.41176,375.800471 1053.44753,451.764706 960,451.764706 C866.552471,451.764706 790.588235,375.800471 790.588235,282.352941 C790.588235,188.905412 866.552471,112.941176 960,112.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionReplyDarkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionReplyDarkSolid, _Component);

  var _super = _createSuper(IconDiscussionReplyDarkSolid);

  function IconDiscussionReplyDarkSolid() {
    _classCallCheck(this, IconDiscussionReplyDarkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionReplyDarkSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussionReplyDark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDiscussionReplyDarkSolid.displayName = "IconDiscussionReplyDarkSolid";
  return IconDiscussionReplyDarkSolid;
}(Component);

IconDiscussionReplyDarkSolid.glyphName = 'discussion-reply-dark';
IconDiscussionReplyDarkSolid.variant = 'Solid';
IconDiscussionReplyDarkSolid.deprecated = true;
IconDiscussionReplyDarkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionReplyDarkSolid;
export { IconDiscussionReplyDarkSolid };